import React, { CSSProperties, PropsWithChildren } from 'react';
import { useMobile } from '../hook/usePlatform';

export enum FontWeightType {
  w400 = 400, w500 = 500, w600 = 600, w700 = 700, w800 = 800, w900 = 900,

}

interface TextPropType {
  // eslint-disable-next-line react/no-unused-prop-types
  fontWeight?:FontWeightType | FontWeightType.w500,
  style?:CSSProperties,
}

// eslint-disable-next-line max-len
const DefaultText:React.FC<PropsWithChildren<TextPropType>> = ({ children, style }) => (
  <div style={{ whiteSpace: 'pre-line', ...style }}>
    {children}
  </div>
);

export const TitleLarge : React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => (
  <DefaultText style={{ fontWeight, fontSize: 24, ...style }}>
    {children}
  </DefaultText>
);
export const TitleMedium : React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => (
  <DefaultText style={{ fontWeight, fontSize: 22, ...style }}>
    {children}
  </DefaultText>
);

export const HeadingLarge : React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => {
  const isMobile = useMobile();
  return (
    <DefaultText style={{ fontWeight, fontSize: isMobile ? 24 : 40, ...style }}>
      {children}
    </DefaultText>
  );
};
export const HeadingMedium : React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => {
  const isMobile = useMobile();
  return (
    <DefaultText style={{ fontWeight, fontSize: isMobile ? 20 : 36, ...style }}>
      {children}
    </DefaultText>
  );
};

export const HeadingSmall : React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => {
  const isMobile = useMobile();
  return (
    <DefaultText style={{ fontWeight, fontSize: isMobile ? 18 : 32, ...style }}>
      {children}
    </DefaultText>
  );
};

export const LabelLarge :React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => {
  const isMobile = useMobile();
  return (
    <DefaultText style={{ fontWeight, fontSize: isMobile ? 17 : 20, ...style }}>
      {children}
    </DefaultText>
  );
};

export const LabelMedium :React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => {
  const isMobile = useMobile();
  return (
    <DefaultText style={{
      whiteSpace: 'pre-line', fontWeight, fontSize: isMobile ? 16 : 17, ...style,
    }}
    >
      {children}
    </DefaultText>
  );
};

export const Caption :React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => (
  <DefaultText style={{
    whiteSpace: 'pre-line', fontWeight: FontWeightType.w700 ?? fontWeight, fontSize: 16, ...style,
  }}
  >
    {children}
  </DefaultText>
);

export const LabelSmall :React.FC<PropsWithChildren<TextPropType>> = ({ fontWeight, children, style }) => (
  <DefaultText style={{
    whiteSpace: 'pre-line', fontWeight, fontSize: 13, ...style,
  }}
  >
    {children}
  </DefaultText>
);
